// Shared module for ErrorBoundary global reference
// This allows index.js and ErrorBoundary.js to share the same reference

let globalErrorBoundaryRef = null;

export const setGlobalErrorBoundaryRef = (ref) => {
  globalErrorBoundaryRef = ref;
};

export const getGlobalErrorBoundaryRef = () => {
  return globalErrorBoundaryRef;
};

export const clearGlobalErrorBoundaryRef = () => {
  globalErrorBoundaryRef = null;
};

// Function to trigger error boundary from anywhere
export const triggerErrorBoundary = (error, errorInfo = null) => {
  if (globalErrorBoundaryRef) {
    globalErrorBoundaryRef.handleError(error, errorInfo);
  } else {
    // If ErrorBoundary hasn't mounted yet, store the error and handle it when it mounts
    if (typeof window !== "undefined") {
      window.__pendingError = { error, errorInfo };
    }
  }
};
